"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerNote = exports.BannerHeader = exports.BannerScope = exports.BannerType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Elevation_1 = require("../../common/enums/Elevation");
var Button_1 = __importStar(require("../button/Button"));
var Icon_1 = __importDefault(require("../icon/Icon"));
var VisuallyHidden_1 = __importDefault(require("../common/VisuallyHidden"));
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var BannerType;
(function (BannerType) {
    BannerType["ATTENTION"] = "attention";
    BannerType["ERROR"] = "error";
    BannerType["INFO"] = "info";
    BannerType["SUCCESS"] = "success";
    BannerType["TIP"] = "tip";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
var BannerScope;
(function (BannerScope) {
    BannerScope["CONTENT"] = "content";
    BannerScope["PAGE"] = "page";
    BannerScope["SITE"] = "site";
})(BannerScope = exports.BannerScope || (exports.BannerScope = {}));
var Banner = function (props) {
    var children = props.children, classes = props.classes, dismiss = props.dismiss, dismissAltText = props.dismissAltText, elevation = props.elevation, headline = props.headline, note = props.note, icon = props.icon, onDismiss = props.onDismiss, scope = props.scope, stacked = props.stacked, type = props.type, otherProps = __rest(props, ["children", "classes", "dismiss", "dismissAltText", "elevation", "headline", "note", "icon", "onDismiss", "scope", "stacked", "type"]);
    var bannerHeader = getComponent(children, headline, exports.BannerHeader);
    var bannerNote = getComponent(children, note, exports.BannerNote);
    var bannerIcon = getBannerIcon(type, icon);
    return (react_1.default.createElement("div", __assign({ className: getClassNames(type, classes, elevation, scope, stacked), role: "alert" }, otherProps),
        bannerIcon && (react_1.default.createElement("div", { className: "fds-banner-icon fds-cell all-cell-shrink" }, bannerIcon)),
        react_1.default.createElement("div", { className: "fds-banner-content fds-cell all-cell-fill" },
            react_1.default.createElement("div", { className: "fds-grid" },
                bannerHeader,
                bannerNote)),
        dismiss && (react_1.default.createElement("div", { className: "fds-banner-dismiss fds-cell all-cell-shrink" },
            react_1.default.createElement(Button_1.default, { onClick: function (e) { e.stopPropagation(); onDismiss && onDismiss(e); }, type: Button_1.ButtonType.ROUND, variant: Button_1.RoundButtonType.FLAT },
                react_1.default.createElement(Icon_1.default, { name: "close" }),
                react_1.default.createElement(VisuallyHidden_1.default, null, dismissAltText))))));
};
Banner.defaultProps = {
    dismissAltText: 'Close',
    scope: BannerScope.PAGE,
    type: BannerType.INFO
};
var getBannerIcon = function (type, icon) {
    if (icon || icon === null) {
        return icon;
    }
    switch (type) {
        case BannerType.ERROR:
            return react_1.default.createElement(Icon_1.default, { name: "error" });
        case BannerType.SUCCESS:
            return react_1.default.createElement(Icon_1.default, { name: "check" });
        case BannerType.TIP:
            return react_1.default.createElement(Icon_1.default, { name: "lightbulb-outline" });
        case BannerType.ATTENTION:
            return react_1.default.createElement(Icon_1.default, { name: "warning" });
        default:
            return react_1.default.createElement(Icon_1.default, { name: "info-outline" });
    }
};
var getComponent = function (children, content, Component) {
    var matchedComponents = ChildrenUtils_1.filterChildrenIn(children, (react_1.default.createElement(Component, null)).type);
    if (matchedComponents && matchedComponents.length > 0) {
        return matchedComponents[0];
    }
    else if (content) {
        return react_1.default.createElement(Component, null, content);
    }
    return null;
};
var BannerHeader = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "fds-banner-header fds-cell all-cell-shrink" },
        react_1.default.createElement("h3", { className: "fds-banner-headline" }, children)));
};
exports.BannerHeader = BannerHeader;
var BannerNote = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "fds-banner-note fds-cell all-cell-fill" }, typeof children === 'string' ? react_1.default.createElement("p", null, children) : children));
};
exports.BannerNote = BannerNote;
var getClassNames = function (type, classes, elevation, scope, stacked) {
    var _a;
    return classnames_1.default('fds-banner', "fds-banner-" + type.toLowerCase(), 'fds-grid', (_a = {},
        _a["elevation-" + elevation] = (elevation && elevation !== Elevation_1.DEFAULT_ELEVATION),
        _a["fds-banner-scope-" + scope] = (scope === BannerScope.CONTENT || scope === BannerScope.SITE),
        _a['fds-banner-stacked'] = stacked,
        _a), classes);
};
exports.default = Banner;
